import type { Integration } from '@sentry/core';
import * as Sentry from '@sentry/react';
import axios from 'axios';

const integrations: Integration[] = [Sentry.browserTracingIntegration()];

if (import.meta.env.MODE === 'production') {
  integrations.push(
    Sentry.replayIntegration({
      networkDetailAllowUrls: [window.location.origin],
      maskAllText: false,
      maskAllInputs: false,
    }),
  );
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: ['Network Error', 'Request failed with status code 400'],
  beforeSend: (event, hint) => {
    const error = hint?.originalException;
    const isAxios400Error =
      axios.isAxiosError(error) &&
      !!error.response?.status &&
      error.response?.status >= 400 &&
      error.response?.status < 500;

    if (isAxios400Error) {
      event.level = 'info';
    }

    return event;
  },
});
